// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"u0-z"};